export enum reportConstants {
  breakdownAll = 'ALL',
  breakDownMales = 'MALE',
  breakDownFemales = 'FEMALE',
  // percentileBand = [1, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90],
}

export const getTraitListByAnalysis = (analysisId: number) => {
  const traitList = [];
  traitList.push({
    shortCode: 'B', traitCode: 'wt', group: 'weights', excl: [],
  });
  traitList.push({
    shortCode: 'W', traitCode: 'wt', group: 'weights', excl: [],
  });
  traitList.push({
    shortCode: 'P', traitCode: 'wt', group: 'weights', excl: [],
  });
  traitList.push({
    shortCode: 'Y', traitCode: 'wt', group: 'weights', excl: [],
  });
  // TERM SHEDDERS
  if (analysisId === 2 || analysisId === 30) {
    traitList.push({
      shortCode: 'H', traitCode: 'wt', group: 'weights', excl: [],
    });
    // traitList.push({
    //   shortCode: 'A', traitCode: 'wt', group: 'weights', excl: [],
    // });

    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  // MAT SAMM CORRIEDALE FISRT
  else if (analysisId === 3 || analysisId === 7 || analysisId === 15 || analysisId === 31) {
    // traitList.push({
    //   shortCode: 'A', traitCode: 'wt', group: 'weights', excl: [],
    // });

    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'gfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fd', group: 'wool', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  // DHONE
  else if (analysisId === 28) {
    traitList.push({
      shortCode: 'H', traitCode: 'wt', group: 'weights', excl: [],
    });
    // traitList.push({
    //   shortCode: 'A', traitCode: 'wt', group: 'weights', excl: [],
    // });

    traitList.push({
      shortCode: null, traitCode: 'gfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'gfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'cfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'cfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'ss', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'sl', group: 'wool', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'BRWR', group: 'health', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'BCOV', group: 'health', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  // Merino
  else if (analysisId === 5) {
    traitList.push({
      shortCode: 'H', traitCode: 'wt', group: 'weights', excl: [],
    });
    // traitList.push({
    //   shortCode: 'A', traitCode: 'wt', group: 'weights', excl: [],
    // });

    traitList.push({
      shortCode: null, traitCode: 'gfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'gfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'cfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'cfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'ss', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'sl', group: 'wool', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'BRWR', group: 'health', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'BCOV', group: 'health', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  // BOARGOAT
  else if (analysisId === 10) {
    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  // NSIP
  else if (analysisId === 18 || analysisId === 61 || analysisId === 62 || analysisId === 63 || analysisId === 64 || analysisId === 69) {
    traitList.push({
      shortCode: 'H', traitCode: 'wt', group: 'weights', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'gfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'gfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'cfw', group: 'wool', excl: ['A'],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'cfw', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: 'A', traitCode: 'fd', group: 'wool', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'ss', group: 'wool', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'emd', group: 'carcase', excl: [],
    });
    traitList.push({
      shortCode: null, traitCode: 'fat', group: 'carcase', excl: [],
    });

    traitList.push({
      shortCode: null, traitCode: 'wec', group: 'health', excl: [],
    });
  }
  return traitList;
};
